import React, { Component } from 'react';

import { Col, Row } from 'react-bootstrap';

class ShowAddPagoComprobanteSummary extends Component {

  render() {
    const { data } = this.props;

    return (
      <Row className="mt-3">
        <Col sm="6" md="3" className="pb-3">
          <strong>Saldo anterior: { data.MonedaDR }</strong>
          <br />
          { data.ImpSaldoAnt || '0.00' }
        </Col>

        <Col sm="6" md="3" className="pb-3">
          <strong>Importe Pagado: { data.MonedaP }</strong>
          <br />
          { data.Monto || '0.00' }
        </Col>

        <Col sm="6" md="3" className="pb-3">
          <strong>Saldo insoluto: { data.MonedaDR }</strong>
          <br />
          { data.ImpSaldoInsoluto || '0.00' }
        </Col>

        <Col sm="6" md="3" className="pb-3">
          <strong>Parcialidad:</strong>
          <br />
          { data.NumParcialidad || 1 }
        </Col>
      </Row>
    )
  }
}

export default ShowAddPagoComprobanteSummary;